import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { filter, Observable, Subject, takeUntil, tap } from 'rxjs';
import { SpinnerState } from '../../constantes/spinner-state.enum';
import { SpinnerService } from '../../services/spinner.service';
import { AccessibiliteService } from '../../services/accessibilite.service';

const CHARGEMENT_TERMINE = '#chargementTermine';
const CHARGEMENT_EN_COURS = '#chargementEnCours';
const APP_FOCUS_INITIAL = 'h1';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: false,
})
export class SpinnerComponent implements AfterViewInit, OnDestroy {
  isHidden: boolean = true;
  hideHorsEcran: boolean = false;
  isFocusInitial: boolean = true;
  loadingState$: Observable<SpinnerState>;
  protected readonly spinnerState = SpinnerState;
  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly accessibiliteService: AccessibiliteService,
    private readonly globalStoreService: GlobalStoreService,
    private readonly spinnerService: SpinnerService
  ) {}

  ngAfterViewInit(): void {
    this.loadingState$ = this.spinnerService.isLoading$.pipe(
      takeUntil(this.destroyed$),
      filter((loadingState: SpinnerState) => SpinnerState.START !== loadingState),
      tap((loadingState: SpinnerState) => {
        if (SpinnerState.VISIBLE === loadingState && this.isHidden) {
          this.isHidden = false;
          this.hideHorsEcran = this.isHidden;
          this.accessibiliteService.setFocus(CHARGEMENT_EN_COURS, 250);
        }
        if (SpinnerState.CACHE === loadingState) {
          setTimeout(() => (this.hideHorsEcran = true), 250);
          this.accessibiliteService.setFocus(CHARGEMENT_TERMINE, 100);
          if (this.isFocusInitial) {
            this.accessibiliteService.setFocus(APP_FOCUS_INITIAL);
            this.isFocusInitial = false;
          } else {
            this.applySelector();
          }
          this.isHidden = true;
        }
      })
    );
  }

  private applySelector() {
    this.globalStoreService.getSelector().subscribe((selector) => {
      if (selector) {
        this.accessibiliteService.setFocus(selector);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
